export const ANNO_DOMINI = "AD";
export const BUDDHIST_CALENDAR = "BE";
export type CalendarFormat = "BE|AD" | "AD|BE" | "AD" | "BE";

export const BUDDHIST_FROM_ANNODIMINI = 543;
export const RANGE_YEAR = 100;
export const FORMAT_DATE = "yyyymmdd";
